<script>
import ModalDialog from '../../UI/Modal/ModalDialog.vue'
import ButtonAll from '../../UI/Button/ButtonAll.vue'
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalMethodsMixin, globalVariablesMixin } from '../../../Mixins/global'

export default {
  components: { ButtonAll, ModalDialog },
  mixins: [mixinComponent, globalVariablesMixin, globalMethodsMixin],

  props: {
    decisionId: { type: Number, default: '' },
    refinancerName: { type: String, default: '' },
    demands: { type: Array, default: [] },
    simulationId: { type: Number },
    isCanceled: { type: Boolean, default: false },
  },

  data() {
    return {
      sendingReplay: false,
    }
  },

  methods: {
    sendAffect(demandId) {
      this.postJSON('quotations/' + this.simulationId + '/demands/' + demandId + '/affect', '', {}).then(
        (json) => {
          this.$emit('sent-decision', json)
          this.closeModal()
        },
        (reason) => {
          alert(reason)
        },
      )
    },

    sendReplay() {
      this.sendingReplay = true
      this.patchJSON('decisions/' + this.decisionId + '/replay', '', {}).then(
        (json) => {
          this.sendingReplay = false
          this.$emit('sent-demand', this.decisionId)
          this.closeModal()
        },
        (reason) => {
          alert(reason)
        },
      )
    },

    showModal() {
      this.$refs[`decision${this.decisionId}`].open()
    },

    closeModal() {
      this.$refs[`decision${this.decisionId}`].close(false)
    },
  },
}
</script>
<template>
  <ModalDialog
    :ref="'decision' + decisionId"
    :id="'decision' + decisionId"
    class-modal-dialog="modal-xl"
    @icon-close="closeModal"
    e2e-modal="decision"
  >
    <template #header>
      <h4>{{ $t('simulation.popin.deal.data', { data: refinancerName }) }}</h4>
    </template>
    <template #body>
      <table class="table table-striped _table-bordered table-hover fs-16">
        <thead>
          <tr>
            <th>{{ $t('simulation.number') }}</th>
            <th>{{ $t('simulation.popin.deal.productName') }}</th>
            <th class="modal-deal-desktop text-right">{{ $t('simulation.popin.deal.demandNumber') }}</th>
            <th class="modal-deal-desktop text-right">{{ $t('simulation.popin.deal.amountDemand') }}</th>
            <th class="modal-deal-desktop text-right">{{ $t('simulation.popin.deal.amountAvailable') }}</th>
            <th class="modal-deal-desktop text-right">{{ $t('simulation.popin.deal.validity') }}</th>
            <th class="modal-deal-desktop text-right">{{ $t('simulation.popin.decisionDeal.affect') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="dem in demands" :e2e-row="'demand-' + dem.id">
            <td class="modal-deal-desktop" e2e-data="demandSimulationId">
              <a
                :href="'../devis/simulation.php?i=' + dem.simulationId + '&p=devis&index=simulation'"
                target="_blank"
                >{{ dem.simulationId }}</a
              >
            </td>
            <td class="modal-deal-desktop text-right" e2e-data="demandProductTypeName">{{ dem.productType.name }}</td>
            <td class="modal-deal-desktop text-right" e2e-data="demandNumber">{{ dem.demandNumber }}</td>
            <td class="modal-deal-desktop text-right" e2e-data="demandAmount">
              {{ $n(Number(dem.finance.amount), 'currency') }}
            </td>
            <td class="modal-deal-desktop text-right" e2e-data="demandAvailableContracts">
              {{ $n(Number(dem.outstanding.availableContracts), 'currency') }}
            </td>
            <td class="modal-deal-desktop text-right" e2e-data="demandDecisionValidity">
              {{ setDate(dem.decisionValidity, 'date') }}
            </td>
            <td class="modal-deal-desktop text-right">
              <button
                class="btn btn-success"
                :disabled="isCanceled"
                @click="sendAffect(dem.id)"
                e2e-button="decisionAffect"
              >
                <i class="fas fa-check"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    <template #footer>
      <ButtonAll
        margin="no"
        type="validation"
        label="simulation.popin.decisionDeal.replay"
        @click="sendReplay"
        :loading="sendingReplay"
        :disabled="isCanceled"
        name="decisionReplay"
      />
      <button type="button" class="btn btn-info" @click="closeModal" e2e-button="close">
        {{ $t('main.close') }}
      </button>
    </template>
  </ModalDialog>
</template>
